import {
  Cohort,
  WOOFZ_COACHING,
  WOOFZ_VC6,
} from 'nove8/constants/root-constants'
import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import {
  INITIAL_LANGUAGE,
  LANG_QUERY_PARAM,
  LOCALES,
  SUPPORTED_LOCALES,
} from 'root-constants'
import { routeHistory } from 'route-history'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useSetLanguage = (): void => {
  const { pathname, search } = useLocation()
  const { cohort } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || null,
    })),
  )
  const isVcCohorts = useMemo(
    () => [WOOFZ_VC6, WOOFZ_COACHING].includes(cohort as Cohort),
    [cohort],
  )

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const langQueryParam = URLParams.get(LANG_QUERY_PARAM) || ''

    if (!SUPPORTED_LOCALES.includes(langQueryParam)) {
      const browserLang = window.navigator
        ? window.navigator.language.substring(0, 2)
        : ''
      const lang = SUPPORTED_LOCALES.includes(browserLang)
        ? browserLang
        : INITIAL_LANGUAGE

      useZustandSessionStore.setState({ language: lang })
      URLParams.set(LANG_QUERY_PARAM, lang)
      routeHistory.replace({
        pathname,
        search: URLParams.toString(),
      })
      return
    }

    useZustandSessionStore.setState({
      language: isVcCohorts ? LOCALES.EN : langQueryParam,
    })
  }, [pathname, search, isVcCohorts])
}
